export interface CommentairesEntry {
  revision: string;
  pneumatiques: string;
  reparation: string;
  carrosserie: string;
  controlesTechniques: string;
  sinistre: string;
  brisGlace: string;
  depannageRemorquage: string;
  vehiculeRemplacement: string;
  carteCarburantTelebadge: string;
  commandeLivraisonRestitution: string;
  amendes: string;
  commentaireParDefaut: string;
}

export enum ServiceCopilot {
  RELEVE_KILOMETRIQUE,
  TROUVER_PRESTATAIRE,
  ETAT_DES_LIEUX_VEHICULE,
  REPARATION_CARROSSERIE,
  TRANSMETTRE_DOCUMENT,
  DOCUMENTS_VEHICULE,
}

export enum Prestations {
  VITRAGE,
  REPARATION,
  REVISION,
  CARROSSERIE,
  PNEUMATIQUE,
  CONTROLE_TECHNIQUE,

}

export enum TypePrestations {
  OUI = 'OUI',
  NON = 'NON',
}

export interface PrestationsVehiculeCopilotEntry {
  prestationCopilot: Prestations;
  typePrestation: TypePrestations;
}

export interface Vehicule {
  id: string;
  numeroDossier: string;
  immatriculation: string;
  typeVehicule: string;
  marqueVehicule: string;
  conducteur: string;
  energie: string;
  modele: string;
  proprietaire: string;
  dateMEC: Date;
  version: string;
  commentaires: CommentairesEntry;
  dernierReleveKilometrique: number;
  releveKilometriqueSource: string;
  dateDernierReleveKilometrique: string;
  entiteClientRepresentation: EntiteClient;
  idClient: string;
  dateFinContrat: Date;
  services: ServiceCopilot[];
  prestationsCopilot: PrestationsVehiculeCopilotEntry[];
  ptac: number;
  logoEntite: string;
  tauxCo2: number;
  critAir: string;
  alertes: Alerte[];
  dateDernierControleTechnique: Date;
  dateDerniereRevision: Date;
  immobilisation: Immobilisation;
}

export interface EntiteClient {
  id: string;
  denomination: string;
}

export interface InfosVehicule {
  idActif: string;
  numeroDossier: string;
  immatriculation: string;
  typeActif: string;
  marque: string;
  energie: string;
  modele: string;
  version: string;
  dateSortie: string | null; // Changé en string | null
  dernierReleveKilometrique: number;
  idCompte: string;
}

export interface Alerte {
  dateCible: Date; // Changé en string
  idActif: string;
  kilometrage: number; // Ajusté pour correspondre au type primitif et gérer null
  motifVisite: string;
  etat: string;
  numeroDossierActif: string;
  typeAlerte: string;
}

export interface VehiculeSimplifie {
  infosVehicule: InfosVehicule;
  alertes: Alerte[];
}

export interface ReleveKilometrique {
  idActif: string;
  kilometrage: number;
  date: Date;
  source: string;
}

export interface DeposerVehiculeCommand {
  dateDepot: Date;
  prestations: Prestations[];
  idFournisseur: string | null;
  nomGarage: string | null;
  adresseGarage: string | null;
}

export interface RecupererVehiculeCommand {
  dateDepot: Date;
  dateRecuperation: Date;
  prestations: Prestations[];
  idFournisseur: string | null;
  nomGarage: string | null;
  adresseGarage: string | null;
}

export interface Immobilisation {
  idActif: string;
  dateDepot: Date;
  dateRecuperation: Date;
  prestations: Prestations[];
  idFournisseur: string | null;
  nomFournisseur: string | null;
  adresseFournisseur: string | null;
}

export interface VehiculeLight {
  idActif: string;
  numeroDossier: string;
  immatriculation: string;
  prestationsCopilot: PrestationsVehiculeCopilotEntry[];
}
